import moment from 'moment';
import { getFiguregroupsMap } from './getter';
import { addTimePos } from './map/getUsersPosition';
import { postData } from './postData';
import { createTreeData } from './reformatItemData';
import { _ } from './translator';

var projectStartDate = null;

const isdevelopment = false
const projectId = isdevelopment ? 165 : window.project_id;
const userId = isdevelopment ? 825 : window.current_user_id;

const totalProjectDays = (startDateStr) => {
    projectStartDate = startDateStr
    let date = moment(startDateStr).format('YYYY-MM-DD')
    let days = moment().diff(date, 'days')
    let allDates = []
    for (let i = 0; i <= days; i++) {
        allDates.push({
            id: date,
            type: "days",
            attributes: {
                day: date,
                time_pos: i
            }
        })
        date = moment(date).add(1, 'days').format('YYYY-MM-DD')
    }
    return allDates
}


export async function getData(urlDict, urlContent=null) {
    let responseData = {};
    try {
        const url = buildUrl(urlDict, urlContent);
        const fetchOptions = getFetchOptions(urlDict, urlContent);
        const response = await fetch(url, fetchOptions);
        console.log('response: ', response);
        if (response.ok) {
            responseData = await response.json();
        } else {
            console.log('error', response);
        }
    } catch (error) {
        console.log('error: ', error.name, error.message);
    }
    return responseData;
}

function buildUrl(urlDict, urlContent) {
    if (urlDict.method === 'POST') {
        return urlDict.value;
    }
    if (urlContent) {
        let url = urlDict.value;
        const urlParams = Object.entries(urlContent);
        for (let i = 0; i < urlParams.length; i++) {
            const bindValue = i === 0 ? '?' : '&';
            const param = urlParams[i][0];
            const value = urlParams[i][1];
            url += `${bindValue}${param}=${value}`;
        }
        return url;
    }
    return urlDict.value;
}

function getFetchOptions(urlDict, urlContent) {
    let fetchOptions = {
        method: urlDict.method
    };
    
    // Add headers
    fetchOptions.headers = {
        'Content-Type': 'application/json'   
    };
    
    // Add Authorization header if token is available (for embed mode)
    if (window.embed && window.authToken) {
        fetchOptions.headers['Authorization'] = `Bearer ${window.authToken}`;
    }
    
    if (urlDict.method === 'POST') {
        fetchOptions.body = JSON.stringify(urlContent);
    }
    
    return fetchOptions;
}

export async function getProjectData(projectId) {
    let projectData = 'unset';
    try {
        const url = `/web-api/project-data?project_id=${projectId}`;
        
        const headers = {};
        // Add Authorization header if token is available (for embed mode)
        if (window.embed && window.authToken) {
            headers['Authorization'] = `Bearer ${window.authToken}`;
        }
        
        let response = await fetch(url, { headers });
        if (response.ok) {
            projectData = await response.json();
            projectData.days = totalProjectDays(projectData.attributes.start_date);
            projectData.figuregroups_map = getFiguregroupsMap(projectData.figures);
        } else {
            console.log('Fallo al cargar la data del proyecto.');
        }
    } catch (error) {
        console.log(error);
    }

    return projectData;
}


export async function getItemsData (project_id, projectData, depth) {

    const headers = {};
    // Add Authorization header if token is available (for embed mode)
    if (window.embed && window.authToken) {
        headers['Authorization'] = `Bearer ${window.authToken}`;
    }

    let items = await fetch('/web-api/projects/' + project_id + '/items?depth='+ depth, { headers })
    let itemsData = {}
    if (items.ok) { 
        itemsData = await items.json()
    }
    if (items.status === 404) {
        console.log("No se encontraron items")
    }
    
    itemsData = createTreeData(projectData, itemsData)

    return itemsData
}


export async function getItemsProgressData (project_id) {
    
    const headers = {};
    // Add Authorization header if token is available (for embed mode)
    if (window.embed && window.authToken) {
        headers['Authorization'] = `Bearer ${window.authToken}`;
    }
    
    let resp = await fetch('/web-api/item-progress?project_id='+ project_id, { headers })
    let progressData = {}
    if (resp.ok) { 
        progressData = await resp.json()
    } else {
        console.log("Error al cargar el progreso del itemizado");
    }
    
    return progressData

}


export async function getCardsGroupsByLevel(projectId, levelId) {
    try {
        let cardsGroupsData = {};
        
        const headers = {};
        // Add Authorization header if token is available (for embed mode)
        if (window.embed && window.authToken) {
            headers['Authorization'] = `Bearer ${window.authToken}`;
        }
        
        let resp = await fetch(`/web-api/get-cards-groups-by-level?project_id=${projectId}&level_id=${levelId}`, { headers });
        if (resp.ok) { 
            cardsGroupsData = await resp.json();
        } else {
            console.log(_("Fallo en getCardsGroupsByLevel"));
        }
        cardsGroupsData = addTimePos(cardsGroupsData, projectStartDate);
        // cardsGroupsData = addPositions(cardsGroupsData)
        return cardsGroupsData;
    } catch (error) {
        console.log(error)
        console.log(_("Fallo en getCardsGroupsByLevel"));
    }
}

export async function getProjectUsers(projectId, filtered) {
    try {
        let errorText = 'Falló al intentar cargar los usuarios.';
        let url = '/web-api/project-users-data';
        let urlContent ={}
        if (filtered) {
            urlContent = {
                project_id: projectId,
                filtered: true
            }
        } else {
            urlContent = {
                project_id: projectId
            }
        }
        let response = await postData(url, urlContent, errorText);
        let usersData = response.status === 'success' ? response.users_data : {};
        return usersData;
    } catch (error) {
        console.log(error)
    }
}

export async function getQualityProgressData(projectId) {
    const headers = {};
    // Add Authorization header if token is available (for embed mode)
    if (window.embed && window.authToken) {
        headers['Authorization'] = `Bearer ${window.authToken}`;
    }
    
    let resp = await fetch('/web-api/quality-progress?project_id='+ projectId, { headers })
    let qualityProgressData = {}
    if (resp.ok) { 
        qualityProgressData = await resp.json()
    } else {
        console.log("Error al cargar el progreso de calidad del itemizado");
    }
    
    return qualityProgressData
}

export async function getUserRole() {
    const headers = {};
    // Add Authorization header if token is available (for embed mode)
    if (window.embed && window.authToken) {
        headers['Authorization'] = `Bearer ${window.authToken}`;
    }
    
    let resp = await fetch('/web-api/get-user-role', { headers })
    let roleData = {}
    if (resp.ok) { 
        roleData = await resp.json()
    } else {
        console.log("Error al cargar el rol del usuario");
    }
    return roleData
}

export async function getUserData() {
    const headers = {};
    // Add Authorization header if token is available (for embed mode)
    if (window.embed && window.authToken) {
        headers['Authorization'] = `Bearer ${window.authToken}`;
    }
    
    let resp = await fetch('/web-api/users/' + userId, { headers })
    let userData = {}
    if (resp.ok) { 
        userData = await resp.json()
    } else {
        console.log("Error al cargar la data del usuario");
    }
    return userData
}

export async function getMatches(projectId) {
    let url = '/web-api/get-matches'
    let urlContent = {
        project_id: projectId,
        matches: [
            {
                first_type: 'levels',
                second_type: 'card_categories'
            },
            {
                first_type: 'levels',
                second_type: 'protocols'
            },
            {
                first_type: 'card_categories',
                second_type: 'protocols'
            },
            {
                first_type: 'levels',
                second_type: 'appartments'
            },
        ]
    }
    let matches = await postData(url, urlContent)
    return matches
}

export async function getCardsData(cardsGroupId) {
    let resp = await fetch(`/web-api/cards_groups/${cardsGroupId}/cards?depth=1`)
    let cardsData = {}
    if (resp.ok) { 
        cardsData = await resp.json()
    } else {
        cardsData = undefined
        console.log(`Error al cargar las cards de cardsgroup_id: ${cardsGroupId}`);
    }
    return cardsData
}

export async function getAxlesData(projectId) {
    let resp = await fetch(`/web-api/projects/${projectId}/axles?fast=False`)
    let axlesData = {}
    if (resp.ok) { 
        axlesData = await resp.json()
    } else {
        console.log("Error al cargar los ejes");
    }
    
    return axlesData
}

export async function getCardsGroupsData(cardsGroupIds) {
    let url = `/web-api/projects/${projectId}/cards_groups`;
    let urlContent = {
        filters: {
            id: cardsGroupIds
        }
    };
    let errorText = 'Falló al intentar recargar tarjetas.';
    let cardsGroupsData = await postData(url, urlContent, errorText);
    return cardsGroupsData;
}

//DEPRECATED
export async function getUserCardsGroupIdsToDo(projectId, userId) {
    let errorText = 'Falló al intentar cargar los registros de un usuario.';
    let url = '/web-api/user-cards-groups-to-do';
    let urlContent = {
        project_id: projectId,
        to_do_user_id: userId
    }
    let response = await postData(url, urlContent, errorText);
    let cardsGroupIds = response.status === 'success' ? response.cards_group_ids : [];
    return cardsGroupIds;
}

export async function getFiguregroupsData(projectId, figuregroupIds) {
    const url = `/web-api/projects/${projectId}/figuregroups`;
    const urlContent = {
        filters: {
            id: figuregroupIds
        },
        depth_path: {
            figures: {
                gps_points: {}
            }
        }
    };
    const errorText = 'Falló al cargar los grupos de figuras.';
    const figuregroupsData = await postData(url, urlContent, errorText);
    return figuregroupsData;
}

export async function getFiguresData(projectId) {
    const url = `/web-api/projects/${projectId}/figures`;
    const urlContent = {
        depth_path: {
            figuregroups: {},
            gps_points: {}
        }
    };
    const errorText = 'Falló al cargar las figuras.';
    const figuresData = await postData(url, urlContent, errorText);
    return figuresData;
}

export async function getAreasData(projectId) {
    let resp = await fetch(`/web-api/projects/${projectId}/areas`)
    let areasData = {}
    if (resp.ok) { 
        areasData = await resp.json()
    } else {
        console.log("Error al cargar las areas");
    }
    return areasData
}

export async function getCardsGroupsWithHistoricalObservations(projectId) {
    const headers = {};
    // Add Authorization header if token is available (for embed mode)
    if (window.embed && window.authToken) {
        headers['Authorization'] = `Bearer ${window.authToken}`;
    }
    
    let resp = await fetch(`/web-api/historical-observations?project_id=${projectId}`, { headers })
    let responseData = {}
    if (resp.ok) { 
        responseData = await resp.json()
    } else {
        console.log("Error al cargar los registros con observaciones históricas");
    }
    return responseData.status === 'success' ? responseData.cards_group_with_observations_ids : []
}

export async function getEnumType(enumName) {
    const headers = {};
    // Add Authorization header if token is available (for embed mode)
    if (window.embed && window.authToken) {
        headers['Authorization'] = `Bearer ${window.authToken}`;
    }
    let resp = await fetch(`/web-api/enums/${enumName}/to_dict`, { headers })
    let customcardTypes = {}
    if (resp.ok) { 
        customcardTypes = await resp.json()
    } else {
        console.log("Error al cargar la data del usuario");
    }
    return customcardTypes
}

export async function getWhatsAppObservationsLocations(projectId) {
    const headers = {
        'Content-Type': 'application/json'
    };
    // Add Authorization header if token is available (for embed mode)
    if (window.embed && window.authToken) {
        headers['Authorization'] = `Bearer ${window.authToken}`;
    }
    
    let url = '/web-api/whatsapp-observations-locations';
    let urlContent = {
        project_id: projectId
    };
    
    let errorText = 'Falló al intentar cargar las observaciones de WhatsApp.';
    let response = await postData(url, urlContent, errorText);
    if (response && response.status === 'success') {
        return response.data || {};
    } else {
        return {};
    }
}